import React from "react";
import Accordion from "react-bootstrap/Accordion";
import PaginationModified from "../../../data/PaginationModified";
import {
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";

const RawLeadLogsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  setModValues,
  userInfoData,
}) => {
  const isMarketing = userInfoData?.account_type === "marketing";

  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((lead, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  <h3 className="lead-name">{lead?.user_name || "NA"}</h3>

                  {!isMarketing && (
                    <button
                      className="lead-log view-lead"
                      type="button"
                      style={{
                        minWidth: "120px",
                        background: "#C90808",
                        color: "#fff",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontSize: "15px",
                        padding: "10px",
                        border: "none",
                      }}
                      onClick={() =>
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          rowData: lead,
                          modName: "add",
                        }))
                      }
                    >
                      Add To LMS
                    </button>
                  )}
                </div>

                <div className="card-other-info">
                  <span className="value semi-bold">
                    {lead?.user_mobile || "NA"}
                  </span>
                  {lead?.email ? (
                    <span className="value email semi-bold">
                      {lead?.user_email || "NA"}
                    </span>
                  ) : null}
                  <span className="value semi-bold">
                    {lead?.gym_name || "NA"}
                  </span>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="heade-info">
                          <span className="title">Sub Add Date</span>
                          <span className="value">
                            {lead?.subscription_added
                              ? formatDateTimezon(lead.subscription_added)
                              : "-"}
                          </span>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value">
                            <span className="label">Sub Start Date</span>
                            <span className="value">
                              {lead?.subscription_start_date
                                ? formatDateTimezon(
                                    lead.subscription_start_date
                                  )
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Sub Expire Date</span>
                            <span className="value">
                              {lead?.subscription_expire_date
                                ? formatDateTimezon(
                                    lead.subscription_expire_date
                                  )
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Amount</span>
                            <span className="value">
                              ₹{convertThenFormat(lead?.total_amount || 0)}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">plan</span>
                            <span className="value multi-value">
                              {lead?.plan_name || "NA"}
                              <br />
                              <small style={{ textTransform: "capitalize" }}>
                                ({lead?.type || ""})
                              </small>
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">Sub Added By</span>
                            <span className="value">
                              {lead?.sub_added_by_name || "NA"} (
                              {lead?.sub_added_by_account_type?.replace(
                                /_/g,
                                " "
                              ) || ""}
                              )
                              <br />
                              <small style={{ textTransform: "lowercase" }}>
                                {lead?.sub_added_by_mobile || ""}
                                <br />
                                {lead?.sub_added_by_email || ""}
                              </small>
                            </span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default RawLeadLogsMobile;
